<template>
  <div>

    <b-container v-show="!isCancelled">
      <b-row>
        <b-col>
          <h4>Are you a New or an Existing patient?</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button class="m-2" variant="primary" to="/form/new">New</b-button>
          <b-button class="m-2" variant="primary" to="/form">Existing</b-button>
          <b-button class="m-2" variant="outline-secondary" @click="closePage">Cancel</b-button>
        </b-col>
      </b-row>
    </b-container>

    <div v-show="loadError != ''" class="text-danger">
      {{loadError}}
    </div>

    <div v-show="isCancelled">
      <h4>This page can be closed.</h4>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
// import RegistrationForm from '@/components/RegistrationForm.vue';
import {debug, parseNetworkError} from '@/components/globals.js';

export default {
  name: 'Home',


  data() {
    return {
      isCancelled: false,
      loadError: ''
    }
  },

  // components: {
  //   RegistrationForm
  // },


  computed: {
    consultUid() {
      return this.$store.getters['form/consultUid']
    },
  },

  mounted() {
    debug('Main mounted');

    this.$store.dispatch('form/setFormData', {});
    this.$store.dispatch('form/setImagesData', []);
    this.$store.dispatch('form/setConsultUid', '');
  },


  beforeRouteLeave(to, from, next) {
  // beforeRouteLeave(to) {
    const toPath = to.path;

    debug('Main beforeRouteLeave: to=' + toPath);
  
    this.loadError = '';
    const pathParts = to.path.split('/');
    const toTest = pathParts[1];
    if (toTest == 'form') {
      this.$store.dispatch('form/loadConsultUid')
        .then(() => {
          debug('Main beforeRouteLeave: form/loadConsultUid returned OK');

          if (this.consultUid != '') {
            next();
          } else {
            this.loadError = 'Server returned empty consult UID';
          }
        }, error => {
          const parsedError = parseNetworkError(error);
          debug('Main beforeRouteLeave: form/loadConfig error: ' + parsedError.text);
          this.loadError = parsedError.text;
        });
    } else {
      alert('Invalid route');
    }
  },



  methods: {
    closePage() {
      this.isCancelled = true;
      this.loadError = '';

      window.close();
    }
  }
}
</script>


<style scoped>
</style>